import React from 'react';
import {withDynamicComponents} from 'higher-order-components';
import Equipment from '../../containers/equipment';
import EquipmentContainer from '../../blocks/equipment-container';

const EquipmentBlock = props => <Equipment {...props} />;
EquipmentBlock.displayName = 'Equipment';

export default withDynamicComponents({
  componentWhitelist: [
    EquipmentContainer,
  ],
  mapInputToOutput: [
    ['equipmentContainer', 'equipmentContainer'],
  ],
})(EquipmentBlock);



// WEBPACK FOOTER //
// ./src/blocks/equipment/index.jsx